import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.959 10.5723C11.959 10.8301 11.8652 11.0527 11.6777 11.2402L10.3242 12.6113C10.1367 12.7988 9.9082 12.8926 9.63867 12.8926C9.36914 12.8926 9.14062 12.7988 8.95312 12.6113L6 9.6582L3.04688 12.6113C2.85938 12.7988 2.63086 12.8926 2.36133 12.8926C2.0918 12.8926 1.86328 12.7988 1.67578 12.6113L0.322266 11.2402C0.134766 11.0527 0.0410156 10.8301 0.0410156 10.5723C0.0410156 10.3027 0.134766 10.0742 0.322266 9.88672L3.27539 6.93359L0.322266 3.98047C0.134766 3.79297 0.0410156 3.56445 0.0410156 3.29492C0.0410156 3.02539 0.134766 2.79687 0.322266 2.60938L1.67578 1.23828C1.86328 1.05078 2.0918 0.957031 2.36133 0.957031C2.63086 0.957031 2.85938 1.05078 3.04688 1.23828L6 4.19141L8.95312 1.23828C9.14062 1.05078 9.36914 0.957031 9.63867 0.957031C9.9082 0.957031 10.1367 1.05078 10.3242 1.23828L11.6777 2.60938C11.8652 2.79687 11.959 3.02539 11.959 3.29492C11.959 3.56445 11.8652 3.79297 11.6777 3.98047L8.72461 6.93359L11.6777 9.88672C11.8652 10.0742 11.959 10.3027 11.959 10.5723Z",
		fill: "#979797"
	})
});
export default SvgClose;
